import {memo, useState, useCallback} from 'react'

import GooglePayButtonComponent from '@google-pay/button-react'

import {posthogTrack} from 'src/utils'
// import {useCheckout} from '@/src/utils/context/CheckoutProvider'

/**
 * https://developers.google.com/pay/api/web/guides/tutorial
 */
const CONFIGURATION: Omit<google.payments.api.PaymentDataRequest, 'transactionInfo'> = {
	apiVersion: 2,
	apiVersionMinor: 0,
	merchantInfo: {
		merchantId: 'BCR2DN4TTXM6JFLW',
		merchantName: 'Form Source LLC',
	},
	allowedPaymentMethods: [
		{
			type: 'CARD',
			parameters: {
				allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
				allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'],
			},
			tokenizationSpecification: {
				type: 'PAYMENT_GATEWAY',
				parameters: {
					gateway: 'checkoutltd',
					gatewayMerchantId: process.env.NEXT_PUBLIC_CHECKOUT_PUBLIC_KEY!,
				},
			},
		},
	],
}

type TGooglePayButtonProps = {
	price?: number
}

const environment = process.env.NODE_ENV === 'production' ? 'PRODUCTION' : 'TEST'
const GooglePayButton = memo(({price = 1.99}: TGooglePayButtonProps) => {
	const [hasError, setHasError] = useState(false)
	// const {pay} = useCheckout()
	const pay = () => {
		console.log('pay')
	}

	const handleSubmit = useCallback(
		async (googlePayToken: string) => {
			setHasError(false)
			// await pay({
			// 	alternativePaymentType: 'googlepay',
			// 	alternativePaymentToken: JSON.parse(googlePayToken),
			// })
		},
		[pay],
	)

	return (
		<>
			<div style={{width: '100%', height: 40, paddingTop: '10px'}}>
				<GooglePayButtonComponent
					buttonSizeMode="fill"
					buttonType="pay"
					environment={environment}
					paymentRequest={{
						...CONFIGURATION,
						transactionInfo: {
							totalPriceStatus: 'FINAL',
							totalPrice: String(price),
							currencyCode: 'USD',
						},
					}}
					onLoadPaymentData={(paymentRequest) => {
						handleSubmit(paymentRequest.paymentMethodData.tokenizationData.token)
					}}
					onError={() => {
						setHasError(true)
					}}
					onClick={() =>
						posthogTrack('subscription/btn_clicked', {type: 'google pay', gateway: 'checkoutltd'})
					}
					style={{display: 'block', width: '100%'}}
				/>
			</div>
			{hasError && (
				<div className="fadeIn" style={{color: 'var(--red400)', padding: '10px 0'}}>
					Something went wrong while processing payment.
					<br /> Please try again later.
				</div>
			)}
		</>
	)
})

GooglePayButton.displayName = 'GooglePayButton'

export default GooglePayButton
